import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

export type CssDirectives = { [cssDirective: string]: string };
type StyleDefinitions = { [key in BackgroundStyles]: CssDirectives };

enum BackgroundStyles {
  Lines = 'lines',
  Grid = 'grid',
  Axis = 'axis',
  White = 'white',
  Gray = 'gray',
  ElementarySchoolLines = 'elementarySchoolLines',
}

const backgroundDefinitions: StyleDefinitions = {
  [BackgroundStyles.White]: {
    backgroundColor: '#ffffff',
  },
  [BackgroundStyles.Gray]: {
    backgroundColor: '#b6b6b6',
  },
  [BackgroundStyles.Axis]: {
    backgroundImage:
      'linear-gradient(transparent calc(50% - 1px), black calc(50% - 1px), transparent calc(50% + 1px)), linear-gradient(90deg, transparent calc(50% - 1px), black calc(50% - 1px), transparent calc(50% + 1px))',
  },
  [BackgroundStyles.Lines]: {
    backgroundImage:
      'linear-gradient(0deg, #000000 0.82%, #ffffff 0.82%, #ffffff 50%, #000000 50%, #000000 50.82%, #ffffff 50.82%, #ffffff 100%)',
    backgroundSize: '5rem 5rem',
  },
  [BackgroundStyles.Grid]: {
    backgroundImage:
      'linear-gradient(to right, grey 1px, transparent 1px), linear-gradient(to bottom, grey 1px, transparent 1px)',
    backgroundSize: '2rem 2rem',
  },
  [BackgroundStyles.ElementarySchoolLines]: {
    backgroundImage: `linear-gradient(
      0deg, #40709D 0.82%, #ffffff 0.82%, #ffffff 33.33%, #40709D 33.33%, #40709D 34.97%,
      #ffffff 34.97%, #ffffff 68.3%, #40709D 68.3%, #40709D 69.94%, #ffffff 69.94%, #ffffff 100%)`,
    backgroundSize: '5rem 5rem',
  },
};

@Component({
  selector: 'txtb-drawer-background-tool',
  templateUrl: './drawer-background-tool.component.html',
  styleUrls: ['./drawer-background-tool.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DrawerBackgroundToolComponent {
  @Input() activeColor: string | null | undefined;
  @Input() disabledColor: string | null | undefined;
  @Input() isOffline!: boolean;
  @Input() isZoomed = false;
  @Output() backgroundStyle = new EventEmitter<CssDirectives>();

  backgroundStyles = BackgroundStyles;
  pickedBackground?: BackgroundStyles;
  tooltip = false;

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent): void {
    if (this.tooltip && !this.elementRef.nativeElement.contains(event.target)) {
      this.tooltip = false;
    }
  }

  sendStyles(styleType: BackgroundStyles): void {
    this.backgroundStyle.emit(backgroundDefinitions[styleType]);
    this.tooltip = false;
    this.pickedBackground = styleType;
  }
}
